import React, { useState } from "react";
import { BsFileEarmarkArrowUp } from "react-icons/bs";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { NotificationContainer } from "react-notifications";
import toastr from "toastr";

const IncidentEvidence = ({ extensions, description, onChangeFile, onChangeDescription }) => {
    const [loading, setLoading] = useState(false);

    const onChangeHandler = async ({ target }) => {
        const file = target.files[0];
        target.value = null;

        if (!description) return toastr.warning("Please enter a description first!");

        if (!file) return;

        const extension = file.name.split(".").pop().toLowerCase();

        if (!extensions.includes(extension)) return toastr.warning(`Only ${extensions.map((ext) => ext.toUpperCase()).join(", ")} file(s) allowed!`);

        setLoading(true);
        const formData = new FormData();

        formData.append("alias", description);
        formData.append("file", file);

        const response = await CommmonService.uploadDocument(formData);
        setLoading(false);

        if (!response?.status) return toastr.error(response?.message);

        onChangeFile({ file }, response.data);
    };

    return (
        <div className={"form-group mb-1"}>
            {loading && (
                <div className="siteLoader">
                    <div className="spinner-bubble spinner-bubble-info m-5" />
                </div>
            )}
            <div className="alias_docUpload">
                <input type="text" class="form-control" placeholder="Description" value={description} onChange={({ target: { value } }) => onChangeDescription(value)} />
                <div className="uploadFileBtn">
                    <label htmlFor="upload-single-file">
                        <BsFileEarmarkArrowUp />
                    </label>
                    <input className="uploadFile" type="file" onChange={onChangeHandler} />
                </div>
            </div>
            <NotificationContainer />
        </div>
    );
};

export default IncidentEvidence;
